import { render, staticRenderFns } from "./CMAddContactGroup.vue?vue&type=template&id=4bd72d39&"
import script from "./CMAddContactGroup.vue?vue&type=script&lang=js&"
export * from "./CMAddContactGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd72d39')) {
      api.createRecord('4bd72d39', component.options)
    } else {
      api.reload('4bd72d39', component.options)
    }
    module.hot.accept("./CMAddContactGroup.vue?vue&type=template&id=4bd72d39&", function () {
      api.rerender('4bd72d39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/popups/contacts/CMAddContactGroup.vue"
export default component.exports